<template>
  <div class="image-feature-container" :class="spaceLevel">
    <div class="image-content">
      <img 
        :src="ad.url" 
        :alt="ad.val" 
        class="image-element"
        @load="onImageLoad"
        @error="onImageError"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageAd",
  props: {
    ad: {
      type: Object,
      required: true
    },
    spaceLevel: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      index: 0
    };
  },
  methods: {
    onImageLoad(event) {
      const img = event.target;
      const aspectRatio = img.naturalWidth / img.naturalHeight;
      
      // Categorize image type based on aspect ratio
      let imageType;
      if (Math.abs(aspectRatio - 1) < 0.1) {
        imageType = 'square';
      } else if (aspectRatio > 1.2) {
        imageType = 'landscape';
      } else {
        imageType = 'portrait';
      }
      
      this.$emit('imageLoaded', {
        aspectRatio,
        type: imageType
      });
    },
    onImageError() {
      // Fallback to square aspect ratio if image fails to load
      this.$emit('imageError', {
        aspectRatio: 1,
        type: 'square'
      });
    }
  }
};
</script>

<style scoped>
.image-feature-container {
  width: 100%;
  height: 100%;
}

.image-content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.image-element {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  cursor: pointer;
}

</style>